'use client';

import { useMediaQueries } from '@commons/contexts/responsive';

import LogoMenuDesktop from './Desktop';
import LogoMenuMobile from './Mobile';

/**
 * GardaWorld Footer LogoMenu component.
 *
 * Renders the appropriate component based on the screen size.
 */

export const LogoMenu = () => {
  const { ready, minWidth } = useMediaQueries();

  const isMobile = ready && !minWidth.lg;

  return (
    <>
      {!isMobile && <LogoMenuDesktop />}
      {isMobile && <LogoMenuMobile />}
    </>
  );
};

export default LogoMenu;
